import AnimatedIcon from '../../reels/AnimatedIcon';
import WildTextAnim from '../../reels/WildTextAnim';
import { Graphics } from 'pixi.js';
import { GameConfigs } from './GameConfigs';

export const ReelConfig = {
	width: 5,
	height: 3,
	iconWidth: 226,
	iconHeight: 228,
	iconRealWidth: 250,
	iconRealHeight: 250,
	iconGap: 5,
	baitTime: 1000,
	scatterCodes: [10],
	divider: 'reel_divider',
	reelsMask: true,
	animations: {
		bg: {
			pattern: 'Active_Frame_000$.png',
			start: 0,
			end: 23,
			speed: 0.5,
			loop: true
		},
		bg2: {
			pattern: 'Passive_Frame_000$.png',
			start: 0,
			end: 24,
			speed: 0.5,
			loop: true
		}
	},

	icons: [
		{
			id: 0,
			IconClass: AnimatedIcon,
			icon: 'minor_5',
			iconBg: 'minor_5_bg',
			iconBlurred: 'minor_5_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// },
				fg: {
					pattern: 'ten$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false
				}
			},
			width: 240,
			height: 240,
			name: 'ten'
		},
		{
			id: 1,
			IconClass: AnimatedIcon,
			icon: 'minor_4',
			iconBg: 'minor_4_bg',
			iconBlurred: 'minor_4_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// },
				fg: {
					pattern: 'J$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false
				}
			},
			width: 240,
			height: 240,
			name: 'jack'
		},
		{
			id: 2,
			IconClass: AnimatedIcon,
			icon: 'minor_3',
			iconBg: 'minor_3_bg',
			iconBlurred: 'minor_3_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// },
				fg: {
					pattern: 'Q$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false
				}
			},
			width: 240,
			height: 240,
			name: 'queen'
		},
		{
			id: 3,
			IconClass: AnimatedIcon,
			icon: 'minor_2',
			iconBg: 'minor_2_bg',
			iconBlurred: 'minor_2_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true,
					scale: {
						x: 0.8,
						y: 0.8
					}
				},
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// },
				fg: {
					pattern: 'K$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false
				}
			},
			width: 240,
			height: 240,
			name: 'king'
		},
		{
			id: 4,
			IconClass: AnimatedIcon,
			icon: 'A00.png',
			iconBg: 'minor_1_bg',
			iconBlurred: 'minor_1_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// },
				fg: {
					pattern: 'A$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false
				}
			},
			width: 240,
			height: 240,
			name: 'ace'
		},
		{
			id: 5,
			IconClass: AnimatedIcon,
			icon: 'telescope00.png',
			iconBg: 'major_5_bg',
			iconBlurred: 'major_5_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: 'telescope$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.85,
						y: 0.85
					},
					offsetX: 10,
					offsetY: 10
				}
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// }
			},
			width: 240,
			height: 240,
			name: 'telescope'
		},
		{
			id: 6,
			IconClass: AnimatedIcon,
			icon: 'major_4',
			iconBg: 'major_4_bg',
			iconBlurred: 'major_4_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: 'helmet$.png',
					start: 0,
					end: 57,
					speed: 0.5,
					loop: false
				}
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// }
			},
			width: 240,
			height: 240,
			name: 'helmet'
		},
		{
			id: 7,
			IconClass: AnimatedIcon,
			icon: 'major_3',
			iconBg: 'major_3_bg',
			iconBlurred: 'major_3_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// },
				fg: {
					pattern: 'asteroid$.png',
					start: 0,
					end: 61,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.85,
						y: 0.85
					},
					offsetX: 10,
					offsetY: 10
				}
			},
			width: 240,
			height: 240,
			name: 'asteroid'
		},
		{
			id: 8,
			IconClass: AnimatedIcon,
			icon: 'major_2',
			iconBg: 'major_2_bg',
			iconBlurred: 'major_2_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: 'starship$.png',
					start: 0,
					end: 60,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.85,
						y: 0.85
					},
					offsetX: 15,
					offsetY: 10
				}
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// }
			},
			width: 240,
			height: 240,
			name: 'starship'
		},
		{
			id: 9,
			IconClass: AnimatedIcon,
			icon: 'Alien_Half_00000.png',
			iconBg: 'major_1_bg',
			iconBlurred: 'major_1_blurred',
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: 'Alien_Half_000$.png',
					start: 0,
					end: 91,
					speed: 0.5,
					loop: false,
					precision: 2
					//   scale: {
					//     x: 0.85,
					//     y: 0.85,
					//   },
					//   offsetX: 10,
					//   offsetY: 10,
				}
				// frame: {
				// 	pattern: 'wildflameblue_000$.png',
				// 	start: 0,
				// 	end: 34,
				// 	speed: 0.5,
				// 	loop: true,
				// 	scale: {
				// 		x: 0.85,
				// 		y: 0.85
				// 	},
				// 	offsetX: -11,
				// 	offsetY: -13
				// }
			},
			width: 240,
			height: 240,
			name: 'alien'
		},
		{
			id: 10,
			IconClass: AnimatedIcon,
			Fg2Class: WildTextAnim,
			icon: 'scatter',
			iconBg: 'scatter_bg',
			iconBlurred: 'scatter_blurred',
			isScatter: true,
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: 'SAUCER$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: false,
					offsetX: 0,
					offsetY: -15
				},
				frame: {
					pattern: 'wildframegold_000$.png',
					start: 0,
					end: 34,
					speed: 0.5,
					loop: true,
					scale: {
						x: 0.85,
						y: 0.85
					},
					offsetX: -11,
					offsetY: -13
				},
				fg2Index: 0,
				fg2Data: [
					{
						image: 'reel_scatter_text',
						image_mask: 'reel_scatter_text_mask',
						offsetX: 128,
						offsetY: 180,
						scale: {
							x: 0.856,
							y: 0.856
						}
					}
				]
			},
			width: 240,
			height: 240,
			name: 'scatter'
		},
		{
			id: 11,
			IconClass: AnimatedIcon,
			Fg2Class: WildTextAnim,
			icon: 'wild',
			iconBg: 'wild_bg',
			iconBgRotate: 'wild_bg',
			iconBgBonus: 'Wildflames_00000.png',
			iconBlurred: 'wild_blurred',
			isWild: true,
			isSticked: false,
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: 'Blaster$.png',
					start: 0,
					end: 58,
					speed: 0.5,
					loop: false,
					scale: {
						x: 1.1,
						y: 1.1
					},
					offsetY: -35,
					offsetX: -10,
					sound: 'wild_shooting'
				},
				frame: {
					pattern: 'Wildflames_000$.png',
					start: 0,
					end: 34,
					speed: 0.5,
					loop: true,
					scale: {
						x: 0.85,
						y: 0.85
					},
					offsetX: -11,
					offsetY: -13
				},
				bonusBg: {
					pattern: 'Wildflames_000$.png',
					start: 0,
					end: 34,
					speed: 0.5,
					offsetX: -11,
					offsetY: -13,
					loop: true,
					scale: {
						x: 0.85,
						y: 0.85
					}
				},
				fg2Index: 0,
				fg2Data: [
					{
						image: 'reel_wild_text',
						image_mask: 'reel_wild_text_mask',
						offsetX: 125,
						offsetY: 175
					},
					{
						image: 'reel_wild_text_x2',
						image_mask: 'reel_wild_text_x2_mask',
						offsetX: 125,
						offsetY: 175
					},
					{
						image: 'reel_wild_text_x3',
						image_mask: 'reel_wild_text_x3_mask',
						offsetX: 125,
						offsetY: 175
					},
					{
						image: 'reel_wild_text_x4',
						image_mask: 'reel_wild_text_x4_mask',
						offsetX: 125,
						offsetY: 175
					},
					{
						image: 'reel_wild_text_x5',
						image_mask: 'reel_wild_text_x5_mask',
						offsetX: 125,
						offsetY: 175
					}
				]
			},
			width: 240,
			height: 240,
			name: 'wild'
		},
		{
			id: 12,
			IconClass: AnimatedIcon,
			icon: 'bonus_reel_special_1_static',
			iconBg: 'major_2_bg',
			// iconBlurred: "bonus_reel_special_1_static_blured",
			animation: {
				fog: {
					pattern: 'bgshadowslow_000$.png',
					start: 0,
					end: 59,
					speed: 0.5,
					loop: true
				},
				fg: {
					pattern: '02_CrystalUnstable$.png',
					start: 0,
					end: 71,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.8,
						y: 0.8
					},
					offsetX: 30,
					offsetY: 25
				},
				frame: {
					pattern: 'wildframegold_000$.png',
					start: 0,
					end: 34,
					speed: 0.5,
					loop: true
				}
			},
			width: 240,
			height: 240,
			name: 'special'
		}
	],
	linesConfig: {
		lines: [
			[1, 1, 1, 1, 1],
			[0, 0, 0, 0, 0],
			[2, 2, 2, 2, 2],
			[0, 1, 2, 1, 0],
			[2, 1, 0, 1, 2],
			[0, 0, 1, 0, 0],
			[2, 2, 1, 2, 2],
			[1, 2, 2, 2, 1],
			[1, 0, 0, 0, 1]
		],
		animationTime: GameConfigs.settings.game_animation ? 2000 : 1000
	},
	reelMask: (u, d, w, h) => {
		var maskGraphics = new Graphics();
		maskGraphics.beginFill(0xffffff);
		maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
		maskGraphics.endFill();
		return maskGraphics;
	},
	reelsMask2: (u, d, w, h) => {
		var maskGraphics = new Graphics();
		maskGraphics.beginFill(0xff0000);
		maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
		maskGraphics.endFill();
		// var mask = Sprite.from(Texture.from("reel_mask"));
		// mask.y = -50;
		return maskGraphics;
	}
};
